module.exports = __webpack_public_path__ + "img/image.71e279de.png";